import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Upload, X } from 'lucide-react';

const ImageUploadBox = ({ label, value, onChange, width = '100%', disabled = false }) => {

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Create local preview URL — actual upload happens at save/submit time
        const previewUrl = URL.createObjectURL(file);
        onChange(previewUrl, file);

        // Reset input so same file can be re-selected if needed
        e.target.value = '';
    };

    const handleRemove = () => {
        onChange('', null);
    };

    return (
        <Box sx={{ width: width }}>
            {label && <Typography variant="subtitle2" sx={{ mb: 1 }}>{label}</Typography>}
            <Box
                sx={{
                    width: '100%',
                    paddingTop: '100%', // 1:1 Aspect Ratio
                    position: 'relative',
                    border: value ? '1px solid #e0e0e0' : '2px dashed #e0e0e0',
                    borderRadius: 2,
                    overflow: 'hidden',
                    bgcolor: disabled ? '#f0f0f0' : (value ? 'background.paper' : '#fafafa'),
                    transition: 'border-color 0.2s',
                    opacity: disabled ? 0.6 : 1,
                    pointerEvents: disabled ? 'none' : 'auto',
                    '&:hover': {
                        borderColor: disabled ? '#e0e0e0' : (value ? '#e0e0e0' : 'primary.main')
                    }
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    {value ? (
                        <>
                            <img
                                src={value}
                                alt="Uploaded"
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                            <IconButton
                                size="small"
                                onClick={handleRemove}
                                disabled={disabled}
                                sx={{
                                    position: 'absolute',
                                    top: 4,
                                    right: 4,
                                    bgcolor: 'rgba(0,0,0,0.5)',
                                    color: 'white',
                                    '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                                }}
                            >
                                <X size={16} />
                            </IconButton>
                        </>
                    ) : (
                        <Box
                            component="label"
                            sx={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                color: 'text.secondary'
                            }}
                        >
                            <input
                                type="file"
                                accept="image/*"
                                hidden
                                disabled={disabled}
                                onChange={handleFileChange}
                            />
                            <Upload size={24} style={{ marginBottom: 8, opacity: 0.5 }} />
                            <Typography variant="caption" color="textSecondary">Upload</Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default ImageUploadBox;
